<template>
  <div>
    <component
      :is="page"
      @navigate="navigate"
      @authorization="authorization"
      @cancel="cancel"
      @mobileAuthorization="mobileAuthorization"
      @qrCodeAuthorization="qrCodeAuthorization"
      @clearStatusTimer="clearStatusTimer"
      :requestInfo="requestInfo"
      :errorType="errorType"
      :redirectURL="redirectURL"
      :invalidEmail="invalidEmail"
    />
  </div>
</template>

<script>
import MobileDialog from "../pages/MobileDialog.vue";
import MobileAuthorization from "../pages/MobileAuthorization.vue";
import QRCodeAuthorization from "../pages/QRCodeAuthorization.vue";
import EnterEmail from "../pages/EnterEmail.vue";
import SelectEmail from "../pages/SelectEmail.vue";
import ConfirmOTP from "../pages/ConfirmOTP.vue";
import Pending from "../pages/Pending.vue";
import Pin from "../pages/Pin.vue";
import Error from "../pages/Error.vue";
import { isMobileOnly, browserName, isIOS } from "mobile-device-detect";

export default {
  components: {
    EnterEmail,
    SelectEmail,
    Pending,
    ConfirmOTP,
    Pin,
    Error,
    MobileDialog,
    MobileAuthorization,
    QRCodeAuthorization,
  },
  name: "Auth",
  data() {
    return {
      page: "SelectEmail",
      requestInfo: {
        expiration: 0,
        pinInputted: false,
        otp: "",
      },
      errorType: "canceled",
      redirectURL: "",
      invalidEmail: false,
      isProcessing: false,
      isStatusLoopStart: false,
      isStatusLooping: false,
      isStatusLoopPaused: false,
      prevRoute: null,
    };
  },
  unmounted() {
    this.clearStatusTimer();
  },
  methods: {
    navigate(val) {
      this.errorType = val.errorType;
      this.warningType = val.warningType;
      this.page = val.page;
    },
    setLocalStorageList(email, action) {
      // local storage email list
      let emailList = JSON.parse(localStorage.getItem("emails"));
      if (emailList == null) {
        emailList = [];
      }

      const isEmailExisted = emailList.includes(email);

      if (action == "add") {
        if (!isEmailExisted) {
          emailList.push(email);
        }
        // Add email to email list
        localStorage.setItem("emails", JSON.stringify(emailList));
      } else if (action == "remove") {
        if (isEmailExisted) {
          const index = emailList.indexOf(email);
          if (index > -1) {
            emailList.splice(index, 1);
            // Delete email from the list
            localStorage.setItem("emails", JSON.stringify(emailList));
          }
        }
      }
    },
    async authorization(email) {
      this.invalidEmail = false;
      if (this.isProcessing == true) {
        return;
      }
      this.isProcessing = true;
      this.clearStatusTimer();

      try {
        const postData = {
          email: email,
          login_challenge: this.$route.query.login_challenge,
        };
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/request",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
            body: JSON.stringify(postData),
          }
        );

        if (!res.ok) {
          this.isProcessing = false;
          const resText = await res.text();
          if (resText == "Ph0ARH0003") {
            if (this.page == "SelectEmail") {
              this.setLocalStorageList(email, "remove");
              this.page = "EnterEmail";
              return;
            }
            if (this.page == "EnterEmail") {
              this.invalidEmail = true;
            }
            return;
          }

          this.navigate({
            page: "Error",
            errorType: "reuse",
          });
          return;
        }
        const resData = await res.json();
        this.requestInfo.expiration = resData.expiration;
        this.setLocalStorageList(email, "add");
        this.startStatusTimer();
      } catch (error) {
        this.isProcessing = false;
        this.navigate({
          page: "Error",
          errorType: "reuse",
        });
      }
    },
    async getStatus() {
      if (this.isStatusLoopPaused == true) {
        return;
      }
      if (this.isStatusLooping == false) {
        return;
      }

      try {
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/status?login_challenge=" +
            this.$route.query.login_challenge,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
          }
        );
        if (!res.ok) {
          if (res.status == 404) {
            // doesn't get login challenge yet
            // retry
            setTimeout(this.getStatus, 1000);
            return;
          }
          this.clearStatusTimer();
          this.navigate({
            page: "Error",
            errorType: "reuse",
          });
          return;
        }
        const resData = await res.json();
        this.checkStatus(resData);
        setTimeout(this.getStatus, 1000);
      } catch (error) {
        this.checkStatusLoop();
      }
    },
    checkStatus(resData) {
      switch (resData.status) {
        case "Pending":
          if (this.page == "ConfirmOTP") {
            return;
          }
          this.navigate({
            page: "Pending",
            errorType: "",
          });
          break;
        case "Claimed":
          this.navigate({
            page: "ConfirmOTP",
            errorType: "",
          });
          break;
        case "Error_code":
          this.clearStatusTimer();
          this.redirectURL = resData.redirect_url;
          this.navigate({
            page: "Error",
            errorType: "wrongCode",
          });
          break;
        case "Success_code":
          this.requestInfo.expiration = resData.expiration;
          this.navigate({
            page: "Pin",
            errorType: "",
          });
          break;
        case "Verified_signature":
          this.requestInfo.pinInputted = true;
          break;
        case "Success":
          window.location.replace(resData.redirect_url);
          break;
        case "Expired":
          this.clearStatusTimer();
          this.redirectURL = resData.redirect_url;
          this.navigate({
            page: "Error",
            errorType: "expired",
          });
          break;
        case "Canceled":
          this.clearStatusTimer();
          this.redirectURL = resData.redirect_url;
          this.navigate({
            page: "Error",
            errorType: "canceled",
          });
          break;
        default:
          break;
      }
      const otp = resData.otp;
      if (otp) {
        this.requestInfo.otp = otp;
        if (this.page == "Error") {
          return;
        }
        if (this.page == "Pending") {
          this.navigate({
            page: "ConfirmOTP",
            errorType: "",
          });
        }
      }
    },
    async cancel() {
      try {
        const postData = { login_challenge: this.$route.query.login_challenge };

        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/cancel",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
            body: JSON.stringify(postData),
          }
        );

        if (!res.ok) {
          return;
        }

        const resData = await res.json();
        const url = resData.redirect_url;
        if (url && url != "") {
          this.redirectURL = url;
          return;
        }
      } catch (error) {
        return;
      }
    },
    mobileAuthorization() {
      // Record login challenge
      localStorage.setItem(
        "login_challenge",
        this.$route.query.login_challenge
      );
      // Mobile Login
      if (isIOS == true) {
        window.location =
          "https://" +
          process.env.VUE_APP_URLPATH +
          "x-id.me/xid?request_type=authorization&login_challenge=" +
          this.$route.query.login_challenge +
          "&browser=" +
          browserName;

        var browserNameLowerCase = browserName.toLowerCase();
        if (
          browserNameLowerCase == "gsa" ||
          browserNameLowerCase == "chrome" ||
          browserNameLowerCase == "edge" ||
          browserNameLowerCase == "firefox"
        ) {
          setTimeout(this.startStatusTimer, 1000);
        } else {
          this.$router.push({ name: "mobileAuthorizationCheck" });
        }
      } else {
        window.location =
          "intent://xid.me/xid?request_type=authorization&login_challenge=" +
          this.$route.query.login_challenge +
          "&browser=" +
          browserName +
          "/#Intent;scheme=" +
          process.env.VUE_APP_SCHEME +
          ";package=" +
          process.env.VUE_APP_PACKAGE +
          ";S.browser_fallback_url=https://play.google.com/store/apps/details?id=me.x.id;end";
        setTimeout(this.startStatusTimer, 1000);
      }
    },
    qrCodeAuthorization() {
      // Record login challenge
      localStorage.setItem(
        "login_challenge",
        this.$route.query.login_challenge
      );
      setTimeout(this.startStatusTimer, 1000);
    },
    startStatusTimer() {
      if (this.isStatusLoopStart == true) {
        return;
      }
      this.isStatusLoopStart = true;
      this.isStatusLooping = true;
      this.getStatus();
    },
    clearStatusTimer() {
      this.isStatusLoopStart = false;
      this.isStatusLooping = false;
    },
    checkStatusLoop() {
      if (document.visibilityState === "visible") {
        this.isStatusLoopPaused = false;
        this.getStatus();
        return;
      } else {
        this.isStatusLoopPaused = true;
        return;
      }
    },
  },
  mounted() {
    document.addEventListener("visibilitychange", this.checkStatusLoop);
    this.isDefaultQRCode = JSON.parse(localStorage.getItem("isDefaultQRCode"));
    if (isMobileOnly != true && this.isDefaultQRCode == true) {
      this.page = "QRCodeAuthorization";
      return;
    }
    // mobile login check
    if (isMobileOnly == true) {
      this.page = "MobileAuthorization";
    }
  },
};
</script>
